import {
  encrypt,
  decrypt,
  isEncrypted,
} from '@/utils/managers/cryptoManager.js';
import sessionKeys from '@/utils/sessionKeys.js';

const SENSITIVE_KEYS = new Set([sessionKeys.KEY_USER_PROFILE]);

export default {
  get: (key, defaultValue) => {
    const raw = sessionStorage.getItem(key);
    if (raw === null) {
      return defaultValue ? JSON.parse(defaultValue) : null;
    }

    try {
      if (SENSITIVE_KEYS.has(key)) {
        if (isEncrypted(raw)) {
          return JSON.parse(decrypt(raw));
        }
        // Legacy unencrypted data — auto-migrate
        const parsed = JSON.parse(raw);
        sessionStorage.setItem(key, encrypt(JSON.stringify(parsed)));
        return parsed;
      }
      return JSON.parse(raw);
    } catch {
      return defaultValue ? JSON.parse(defaultValue) : null;
    }
  },
  set: (key, value) => {
    if (value === undefined || value === null) {
      sessionStorage.removeItem(key);
      return;
    }
    let dataToStore = typeof value === 'object' ? JSON.stringify(value) : value;
    if (SENSITIVE_KEYS.has(key)) {
      dataToStore = encrypt(dataToStore);
    }
    sessionStorage.setItem(key, dataToStore);
  },
  clear: (key) => sessionStorage.removeItem(key),
  clearAll: () => sessionStorage.clear(),
};
